import React from 'react';
import type { Criticidade } from '@/hooks/useGeoIntelData';
import { CRIT_COLORS, CRIT_LABELS } from './mapHelpers';

interface MapLegendProps {
  activeCriticidades: Set<Criticidade>;
  onToggleCriticidade: (c: Criticidade) => void;
  counts: Record<Criticidade, number>;
}

const ALL_CRITICIDADES: Criticidade[] = ['critico', 'alerta', 'ok', 'sem_dados'];

const MapLegend: React.FC<MapLegendProps> = ({ activeCriticidades, onToggleCriticidade, counts }) => {
  return (
    <div className="absolute bottom-3 left-3 z-10">
      <div className="bg-card/95 backdrop-blur-xl border border-border/50 rounded-[10px] shadow-md px-3.5 py-3 space-y-2.5">
        <p className="text-xs text-foreground/60 font-semibold uppercase tracking-[0.12em]">
          Criticidade
        </p>
        <div className="flex flex-wrap gap-x-1 gap-y-1">
          {ALL_CRITICIDADES.map(c => {
            const active = activeCriticidades.has(c);
            return (
              <button
                key={c}
                onClick={() => onToggleCriticidade(c)}
                className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs transition-all border
                  ${active
                    ? 'border-border bg-background text-foreground shadow-sm'
                    : 'border-transparent bg-transparent text-muted-foreground/40'
                  }`}
              >
                <div
                  className={`w-3 h-3 rounded-full transition-all ring-1 ring-black/5 ${active ? 'opacity-100 scale-100' : 'opacity-25 scale-90'}`}
                  style={{ backgroundColor: CRIT_COLORS[c] }}
                />
                <span className="font-semibold">{CRIT_LABELS[c]}</span>
                <span className={`text-xs tabular-nums font-medium ${active ? 'text-foreground/60' : 'text-muted-foreground/30'}`}>
                  {counts[c] || 0}
                </span>
              </button>
            );
          })}
        </div>

        <hr className="border-border/40" />
        <div className="flex items-center gap-4 text-xs text-foreground/60">
          <div className="flex items-center gap-1.5">
            <div className="w-4 h-4 rounded-full bg-primary border-[2.5px] border-white flex items-center justify-center text-[7px] font-bold text-white shadow-sm ring-1 ring-black/10">C</div>
            <span className="font-medium">Cluster</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-muted-foreground/50 border-2 border-white shadow-sm ring-1 ring-black/10" />
            <span className="font-medium">Contrato</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-2.5 rounded-[3px] bg-primary/10 border border-primary/30" />
            <span className="font-medium">Território</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;
